import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import { SlotController } from '../../controllers/slot-controller';
import componentStyles from './se-status-bar.css.lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import '../se-container/se-container';
import '../se-heading/se-heading';
/**
 * The SeStatusBar component
 * @element se-status-bar
 * slot - counters: For se-counter components. Max 4.
 * slot - image: Optional image slot.
 */
@customElement('se-status-bar')
export class SeStatusBar extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, true);

  @property({ type: String })
  heading: string;

  @property({ type: String })
  description: string;

  render(): TemplateResult {
    return html` <section class="se-status-bar">
      <div class="se-status-bar--image-slot">
        <slot name="image"></slot>
      </div>
      <se-container>
        <div class="se-status-bar--wrapper">
          <div class="se-status-bar--content">
            <se-heading
              class="se-status-bar--heading"
              level-style="medium"
              level="h3"
              >${this.heading}</se-heading
            >
            <p class="se-status-bar--description">
              ${unsafeHTML(this.description)}
            </p>
          </div>
          <div class="se-status-bar--counter-slot">
            <slot name="counters"></slot>
          </div>
        </div>
      </se-container>
    </section>`;
  }
}
